import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'E-Mobility LandingPage';
  loggedIn = false;

  constructor(private authService: AuthService, public router: Router) { }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(currentUser => {
      this.loggedIn = currentUser.isAuthenticated;
    });
    this.authService.init();
  }

  public login(): void {
    this.authService.login();
  }

  public logout(): void {
    this.authService.logout();
  }
}
